// extracted by mini-css-extract-plugin
module.exports = {"alert":"AppWrapper_alert_2WPvN","closed":"AppWrapper_closed_1UpTd"};